// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a54cc342","800":"9ebfb7c9"}[chunkId] + ".chunk.js";
};